import React from "react";
import { useNavigate } from "react-router-dom";
import background from "./images/background.png";

const karimeKoolerImg =
  "https://res.cloudinary.com/dbvqeiqxb/image/upload/v1783441943/ChatGPT_Image_Jul_7_2026_11_22_24_AM_rptmrg.png";
const momentosDivertidosImg =
  "https://res.cloudinary.com/dbvqeiqxb/image/upload/v1783441886/patito-phone_ei3hq2.png";

const contentItems = [
  {
    id: "karime-kooler",
    image: karimeKoolerImg,
    title: "Canal Oficial",
    description: "Vlogs, Karime Kooler y más \ncontenido oficial.",
    badge: null,
    path: "/youtube",
    accent: "#7dd3fc",
  },
  {
    id: "momentos-divertidos",
    image: momentosDivertidosImg,
    title: "Momentazos",
    description: "Los TikToks que siempre \nterminas repitiendo.",
    badge: "NUEVO",
    path: "/momentos-divertidos",
    accent: "#c4b5fd",
  },
];

const SelectContent = () => {
  const navigate = useNavigate();

  return (
    <div
      className="flex flex-col font-quicksand"
      style={{
        backgroundImage: `url(${background})`,
        backgroundRepeat: "repeat-y",
        backgroundSize: "100% auto",
        backgroundPosition: "top center",
        minHeight: "calc(100vh - 120px)",
      }}
    >
      <div
        className="px-5 pt-6 pb-8 flex flex-col"
        style={{ minHeight: "inherit" }}
      >
        {/* Header */}
        <div className="mb-5">
          <p
            className="text-xs font-bold tracking-widest uppercase"
            style={{ color: "#b06ab3" }}
          >
            Kari TV
          </p>
          <h1
            className="text-xl font-extrabold mt-0.5"
            style={{ color: "#2d1f3d" }}
          >
            ¿Qué se te antoja ver, bb?
          </h1>
        </div>

        {/* Content cards */}
        <div className="flex flex-col gap-4" style={{ flex: 1 }}>
          {contentItems.map((item) => (
            <button
              key={item.id}
              onClick={() => navigate(item.path)}
              className="w-full active:scale-[0.97] transition-transform relative flex flex-col items-center justify-center"
              style={{
                background: "rgba(255,255,255,0.9)",
                borderRadius: "28px",
                padding: "32px 20px",
                boxShadow: "0 4px 24px rgba(176,106,179,0.13)",
                border: `2px solid ${item.accent}`,
                flex: 1,
              }}
            >
              {item.badge && (
                <span
                  className="absolute top-4 right-4 text-white font-bold rounded-full"
                  style={{
                    background: "#f97316",
                    fontSize: "10px",
                    letterSpacing: "0.05em",
                    padding: "3px 10px",
                  }}
                >
                  {item.badge}
                </span>
              )}

              <img
                src={item.image}
                alt={item.title}
                style={{
                  width: "120px",
                  height: "120px",
                  objectFit: "contain",
                  marginBottom: "14px",
                }}
              />

              <p
                className="font-extrabold text-lg leading-tight text-center"
                style={{ color: "#2d1f3d" }}
              >
                {item.title}
              </p>
              <p
                className="text-sm mt-2 leading-snug text-center whitespace-pre-line"
                style={{ color: "#9b7eaa" }}
              >
                {item.description}
              </p>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SelectContent;
